"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishStatus = void 0;
/**
 * Publish Status Enum
 *
 * Represents the publishing status of a pattern after content scanning.
 * Used in moderation snapshot records and pattern publishing workflow.
 *
 * Consumers: lambda-secure, lambda-utilities, free-pattern-warehouse-website
 */
var PublishStatus;
(function (PublishStatus) {
    PublishStatus["AUTO_APPROVED"] = "auto_approved";
    PublishStatus["AUTO_REJECTED"] = "auto_rejected";
    PublishStatus["MANUAL_REVIEW"] = "manual_review";
    PublishStatus["PUBLISHED"] = "published";
})(PublishStatus || (exports.PublishStatus = PublishStatus = {}));
